<div *ngIf="showTextPayload" [innerHTML]="processText(message.textPayload)">
</div>

<div *ngIf="isPrescriptionPayload" class="mt-prescription">
  <div class="mt-title">Prescription</div>
  <div *ngIf="isImagePayload" class="mt-image">
    <ngx-gallery class='mt-gallery' [options]="galleryOptions" [images]="galleryImages"></ngx-gallery>
    <div [innerHTML]="processText(message.textPayload)"></div>
  </div>
  <div *ngIf="!isImagePayload" [innerHTML]="processText(message.textPayload)"></div>
</div>

<div *ngIf="showImagePayload" class="mt-image">
  <ngx-gallery class='mt-gallery' [options]="galleryOptions" [images]="galleryImages"></ngx-gallery>
  <div> {{processText(message.textPayload)}} </div>
</div>
